<template>
  <div class="ts-app-shell_fh">
   <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5 class="dashboard-title">
          <strong >Eligibility</strong>
        </h5>
        <div class="ts-app-shell--header_actions flexed" style="float: right;">
            <button class="ts-btn ts-btn-small" style="width: 150px" @click="back">Back</button>
        </div>
      </div>
      <p>
        View and complete any eligibility forms that you have been assigned and check the status of your completed forms.
      </p>
      <!-- <br/> -->
      <hr />
      <div>
        <div class="box-gray" :span="24">
            <el-row>
                <br>
                <h6>
                    Forms to be completed
                </h6>
                <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <el-table :data="formsToBeCompleted" style="width: 100%" title="Forms to be completed" height="300">
                        <el-table-column label="Form" width="170">
                            <template slot-scope="scope">
                            <span>
                                {{scope.row.formType}}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Date Sent">
                            <template slot-scope="scope">
                            <span>
                                {{scope.row.dateSent | moment("MMMM DD, YYYY")}}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Sent By">
                            <template slot-scope="scope">
                            <span>
                                {{scope.row.sentBy}}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column width="170">
                            <template slot-scope="scope">
                                <el-button class="ts-btn ts-btn-small" style="width: 150px" @click="completeForm(scope.row)">
                                    Complete
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </div>
        <br>
        <br>
        <div class="box-gray" :span="24">
            <el-row>
                <br>
                <h6>
                    Status
                </h6>
                <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <el-table :data="formsCompleted" style="width: 100%" title="Forms to be completed" height="300">
                        <el-table-column label="Form" width="170">
                            <template slot-scope="scope">
                            <span>
                                {{scope.row.formType}}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Date Sent">
                            <template slot-scope="scope">
                            <span>
                                {{scope.row.dateSent | moment("MMMM DD, YYYY")}}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Sent By">
                            <template slot-scope="scope">
                            <span>
                                {{scope.row.sentBy}}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Date Completed">
                            <template slot-scope="scope">
                            <span>
                                {{scope.row.dateCompleted | moment("MMMM DD, YYYY")}}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Status">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == 3">
                                    Approved <!-- status=3 -->
                                    <img src="../../../assets/img/wioa-check.png" style="height: 20px">
                                </span>
                                <span v-else-if="scope.row.status == 5">
                                    Revoked <!-- status=5 -->
                                    <img src="../../../assets/img/wioa-cancel.png" style="height: 20px">
                                </span>
                                <span v-else-if="scope.row.status == 1">
                                    For Review <!-- status=1 -->
                                </span>
                                <span v-else-if="scope.row.status == 2">
                                    For Approval <!-- status=2 -->
                                </span>
                                <span v-else-if="scope.row.status == 4">
                                    Pending <!-- status=4 -->
                                </span>
                                <span v-else-if="scope.row.status == 6">
                                    For Revoked <!-- status=6 -->
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column width="170">
                            <template slot-scope="scope">
                                <el-button class="ts-btn ts-btn-small" style="width: 150px" @click="viewForm(scope.$index, scope.row)">
                                    View
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </div>
      </div>
    </div>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: { TSLoading },
  data(){
    return{
        formsToBeCompleted: [],
        formsCompleted: [],
        loading: false
    }
  },
  computed: {
    isUserAdmin() {        
      return this.$store.state.account.current_user.roles.filter(
          (x) => x.toLowerCase() == "admin").length > 0;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
  },
  mounted() {
    
  },
  updated() {

  },
  created(){
    this.loading = true;
    this.$store
        .dispatch("wioa/getpendingchecklistrequest", encodeURIComponent(this.currentUser.email))
        .then(res => {
            if(res)
            {           
                this.formsToBeCompleted.push({
                    formType : 'WIOA',
                    dateSent : res.dateSent,
                    sentBy : res.caseworkerName,
                    checklistRequestId: res.checklistRequestId
                });
            }
        })
        .catch((error) => {
        //if no records found

        })
        .finally(() => {
            this.loading = false;
        });

    let param = {
        jobSeekerId: [this.$store.state.account.applicant_user_info.jobSeekerId],
        status: ['FORREVIEW','FORAPPROVAL','COMPLETED','REVOKED','FORREVOKE']
    }
    this.$store
        .dispatch("wioa/clientwioalist", param)
        .then(res => {
            if(res.length > 0)
            {              
                res.forEach(element => {
                    this.formsCompleted.push({
                        formType : 'WIOA',
                        dateSent : element.created,
                        sentBy : element.caseWorkerName,
                        dateCompleted : (element.checklistStatus == 3 || element.checklistStatus == 5) ? element.updated : null,
                        status : element.checklistStatus,
                        checklistId: element.checklistId
                    });
                });
            }
        })
        .catch((error) => {
        //if no records found

        })
        .finally(() => {
            this.loading = false;
        });
  },
  beforeDestroy() {

  },
  methods: {
    back(){
        this.$router.push({ name: "jobseeker-dashboard"});
    },
    completeForm(row){
        this.$store
              .dispatch("wioa/getCheckliStstatusByClient", row.checklistRequestId)
              .then(res => {
                // if (
                //   res.checklistStatusId == 0 ||
                //   res.checklistStatusId == 3 ||
                //   res.checklistStatusId == 5
                // ) {
                //   this.$router.push({ name: "WioaChecklist" });
                //   if (res.checklistStatusId == 0)
                //     localStorage.setItem("editChecklist", res.checklistId);
                // } else {
                //   this.showMessagePopup(
                //     "WIOA Checklist",
                //     "﻿You already have a pending WIOA checklist. This feature is not accessible for the meantime.",
                //     "error"
                //   );
                // }

                
                if (res.checklistStatusId == 0)
                {
                    this.$router.push({ name: "WioaChecklist" });
                }
                else
                {
                    localStorage.setItem("editChecklist", res.checklistId);
                    this.$router.push({ name: "WioaChecklist"});
                }
              })
              .catch(() => {
                //if no records found, proceed with creating new
                this.$router.push({ name: "WioaChecklist" });
              })
              .finally(() => {
                this.loading = false;
              });
    },
    viewForm(index, row){
        debugger
        this.$router.push({ name: "ViewChecklist", params: {checklistId: row.checklistId} });
    },
  },
};
</script>

<style lang="scss" scoped>

.box-gray {
    // width: 300px;
    // height: 80px;
    border-radius: 15px;
    border: 1px solid #e4e7ed;
    box-shadow: 1px 1px 5px 1px #e4e7ed;
    margin: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    /* display: flex; */
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    /* -webkit-box-align: center; */
    // -ms-flex-align: center;
    // align-items: center;
    // -webkit-box-pack: center;
    // -ms-flex-pack: center;
    // justify-content: center;
    padding-left: 10px;
}
</style>